'use strict';


$(function(){
  $('form').on('submit', function(){
    const company = ('#company');
    const last_name = ('#last_name');
    const first_name = ('#first_name');
    const kana_last_name = ('#kana_last_name');
    const kana_first_name = ('#kana_first_name');
    const email = ('#email');
    const check_1 = ('#check-1');

    const kana_regexp = '^[\u30a0-\u30ff]+$';
    const email_regexp = '^[a-zA-Z0-9_.+-]+@([a-zA-Z0-9][a-zA-Z0-9-]*[a-zA-Z0-9]*\.)+[a-zA-Z]{2,}$';


    if($(company).val() != ""
    && $(last_name).val() != ""
    && $(first_name).val() != ""
    && $(kana_last_name).val().match(kana_regexp)
    && $(kana_first_name).val().match(kana_regexp)
    && $(email).val().match(email_regexp)
    && $(check_1).prop("checked")){
      $('.download_file').trigger('click');
    }
  })
});

//swiper
const swiper = new Swiper('.swiper', {
  loop: true,
  pagination: {
    el: ".swiper-pagination"
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
